// removed by extract-text-webpack-plugin
module.exports = {"root":"HostContainer__root___3fGot","headerText":"HostContainer__headerText___NUAd6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/HostContainer/HostContainer.scss
// module id = 974
// module chunks = 0